// api.js

import axiosInstance from "../axiosInstance";

export const webhookService = {
  create: async (data, client_id, provider) => {
    try {
      let response = await axiosInstance.post(
        `/webhook?client_id=${client_id}&provider=${provider}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (id) => {
    try {
      let response = await axiosInstance.get(`/webhook?config_id=${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, provider, client_id) => {
    try {
      let response = await axiosInstance.post(
        `/update-webhook?provider=${provider}&client_id=${client_id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (data, shop_name, client_id) => {
    try {
      let response = await axiosInstance.post(
        `/delete-webhook?shop_name=${shop_name}&client_id=${client_id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  registerAll: async (client_id, provider) => {
    try {
      let response = await axiosInstance.post(
        `/register-webhook?client_id=${client_id}&provider=${provider}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
